<template>
  <div class="gpt-viewer-audio">
    <div class="audio-content">
        <div class="line">
            <div class="rightplace">
                {{$dayjs(totalTime * 1000).format('mm:ss')}}
            </div>
        </div>
        <div class="line">
            <el-progress :percentage="(currentTime / totalTime) * 100" :show-text="false"></el-progress>
        </div>
        <div class="line audio-controller">
            <div class="prev" @click="seek(currentTime - 15 < 0 ? 0 : currentTime - 15)">

            </div>
            <div v-show="paused" class="play" @click="play()">
                <i class="ecp-iconfont ecp-icon-mian3"></i>
            </div>
            <div v-show="!paused" class="pause" @click="pause()">
                <i class="ecp-iconfont ecp-icon-mian90"></i>
            </div>
            <div class="next" @click="seek(currentTime + 15 > totalTime ? totalTime - 1 : currentTime + 15)">
            </div>
        </div>
    </div>
    <div class="line">
        &nbsp;
    </div>
    <audio v-show="false" v-if="url" ref="audio" :src="url" @loadedmetadata="audioInit" @timeupdate="audioUpdate" @play="audioPlay" @ended="audioEnd"></audio>
    <v-md-preview v-if="text" class="content" :text="text"></v-md-preview>
  </div>
</template>

<script>
export default {
    name: 'gpt-viewer-audio',
    data () {
        let text = null;
        let totalTime = 1;
        let currentTime = 0;
        let paused = true;
        return { text, totalTime, currentTime, paused };
    },
    props: {
        url: {
            type: String,
            default: null
        },
        textUrl: {
            type: String,
            default: null
        }
    },
    watch: {
        textUrl () {
            this.load();
        }
    },
    mounted () {
        this.load();
    },
    methods: {
        async load () {
            if (!this.url) return;
            let resp = await fetch(this.textUrl);
            let text = await resp.text();
            this.text = text.replace(/([。？！；])(?!\s)/g, '$1\n'); ;
        },

        play () {
            let audio = this.$refs.audio;
            audio.play();
            this.paused = false;
        },

        pause () {
            let audio = this.$refs.audio;
            audio.pause();
            this.paused = true;
        },

        seek (time) {
            let audio = this.$refs.audio;
            audio.currentTime = time;
        },

        audioInit () {
            let audio = this.$refs.audio;
            this.totalTime = audio.duration;
        },

        audioUpdate () {
            let audio = this.$refs.audio;
            this.currentTime = audio.currentTime;
        },

        audioPlay () {
            this.paused = false;
        },
        audioEnd () {
            this.paused = true;
        }
    }
};
</script>
<style scoped lang="scss">
.gpt-viewer-audio {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 2em;
    background: var(--page-bg-img);
    background-size: cover;
    .audio-content {
        height: 100px;
    }
    .content {
        position: relative;
        width: 100%;
        height: calc(100% - 100px);
        background-color: #FFF;
        border-radius: 0.5em;
        padding: 1em;
        overflow: auto;
    }
    .audio-controller {
        position: relative;
        width: 100%;
        flex: 1 1 auto;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        .prev {
            cursor: pointer;
            width: 3em;
            height: 3em;
            background: url(../../../theme/images/icons/icon_audio_prev_15.svg) no-repeat center;
            background-size: contain
        }
        .next {
            cursor: pointer;
            width: 3em;
            height: 3em;
            background: url(../../../theme/images/icons/icon_audio_next_15.svg) no-repeat center;
            background-size: contain
        }
        .play {
            cursor: pointer;
            width: 4em;
            height: 4em;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(270deg, #165DFF 0%, #209BFF 100%);
            border-radius: 50%;
            i {
                font-size: 2em;
                color: #FFF;
                transform: translateX(0.1em);
            }
        }.pause {
            cursor: pointer;
            width: 4em;
            height: 4em;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(270deg, #165DFF 0%, #209BFF 100%);
            border-radius: 50%;
            i {
                font-size: 2em;
                color: #FFF;
            }
        }
    }
    .line {
        padding :0.5em;
    }
    .rightplace {
        float: right;
    }
}
</style>
